import script from "./ClientCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCalendar.vue?vue&type=script&setup=true&lang=js"

import "./ClientCalendar.vue?vue&type=style&index=0&id=5c1efa1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1efa1a"]])

export default __exports__